var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "currentColor",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.349 13.377-7.327 7.327c-.677.677-1.35 1.018-2.022 1.024-.67.006-1.341-.326-2.012-.997L1.624 13.36c-.67-.665-1.003-1.333-.997-2.004.006-.677.348-1.353 1.025-2.03L8.97 2.007C9.646 1.33 10.32.988 10.99.982c.67-.006 1.342.327 2.013.997l7.372 7.364c.671.677 1.003 1.35.997 2.021-.006.665-.347 1.336-1.024 2.013Zm-9.34-10.803c-.341-.006-.68.159-1.015.494l-7.281 7.281c-.323.323-.488.659-.494 1.006-.006.342.162.68.503 1.016l7.263 7.263c.335.335.677.503 1.024.503V2.574Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.ff51278777bae7ea5999b2291d5f4b20.svg";
export { ForwardRef as ReactComponent };